module.exports = __webpack_public_path__ + "static/scale-model-of-classic-travel-network-in-columbia-south-carolina-4fcfc2dae3248d9f52ea895cbff26126.png";